<h1 class="page-title mb-5"></h1>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-4">
      <app-service-sidebar></app-service-sidebar>
    </div>
    <div class="col-md-8"></div>
  </div>
</div>